import type React from 'react';

interface ComponentProps {
  violated: boolean;
  preventSubmit: boolean;
  children: React.ReactNode;
}

function ClientConstraintViolationTarget({ violated, preventSubmit, children }: ComponentProps) {
  return (
    <>
      {violated && (
        <div
          className="activeConstraintTarget"
          data-testid="ClientConstraintViolationTarget"
          data-prevent-submit={preventSubmit}
        />
      )}
      {children}
    </>
  );
}

export default ClientConstraintViolationTarget;
